<template>
  <div class="wrapper">
    <base-circular-loader v-if="loading" />

    <div v-else class="list">
      <div class="list-header  list-header-full-width list-header-primary">
        <div>
          {{ $t("customContentFilter.contentRelatedTo") }}:
        </div>

        <div class="clickable" @click="addFilter">
          {{ $t("customContentFilter.addNewFilter") }}
        </div>
      </div>

      <div v-for="(filter, index) in filters"
          :key="index"
          class="list-item list-item-no-border list-item-sm">
        <custom-filter-item :filter="filter"
                            :child-id="childId"
                            :mode-id="modeId"
                            @openFilter="openFilter"
                            @changeAction="changeAction" />
      </div>
    </div>
  </div>
</template>

<script>
  import CustomFilterItem from '@/components/Child/ChildCustomFilter/CustomFilterItem'
  import analytics from '@/services/analytics'

  export default {
    components: {
      CustomFilterItem
    },

    props: {
      modeId: {
        type: String,
        required: true
      },

      childId: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        loading: true
      }
    },

    created() {
      analytics.sendEvent('CustmContnFltrs_Sc')

      this.loadFiltersData()
    },

    computed: {
      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      ...mapGetters('categories', {
        filters: 'getCustom'
      }),

      groupId() {
        return this.currentUser.group_id
      }
    },

    methods: {
      ...mapActions('categories', {
        loadCustom: 'loadCustom'
      }),

      ...mapActions('children', {
        setCategorySettings: 'setCategorySettings',
        updateCategorySettings: 'updateCategorySettings',
        removeCategorySettings: 'removeCategorySettings'
      }),

      changeAction(filter) {
        const { id, action } = filter

        if (action === 'inactive') {
          this.removeCategorySettings({
            user_id: this.childId,
            mode_id: this.modeId,
            category_id: id
          })

          return
        }

        this.updateCategorySettings({
          user_id: this.childId,
          mode_id: this.modeId,
          category_id: id,
          action
        })
      },

      async loadFiltersData() {
        this.loading = true

        await this.getCustomFilters()
        await this.getCustomFiltersSettings()

        this.loading = false
      },

      getCustomFilters() {
        this.loadCustom(this.groupId)
      },

      getCustomFiltersSettings() {
        this.setCategorySettings({
          user_id: this.childId,
          mode_id: this.modeId
        })
      },

      addFilter() {
        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.customFiltersEditor',
            params: {
              modeId: this.modeId,
              childId: this.childId
            }
          })

          return
        }

        this.showModal('customFiltersEditor', {
          modeId: this.modeId,
          childId: this.childId
        })
      },

      openFilter(filter) {
        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'children.single.customFiltersEditor',
            params: {
              mode: 'update',
              modeId: this.modeId,
              childId: this.childId,
              filterId: filter.id,
              name: filter.description,
              keywords: filter.keywords
            }
          })

          return
        }

        this.showModal('customFiltersEditor', {
          mode: 'update',
          modeId: this.modeId,
          childId: this.childId,
          filterId: filter.id,
          name: filter.description,
          keywords: filter.keywords
        })
      }
    }
  }
</script>
